import SftpUpload from "@/components/schooldata/Upload";
import Classes from "@/components/matching/apple/Classes";
import OrganisationSchools from "@/components/organisation/apple/Schools";
import OrganisationSettings from "@/components/organisation/apple/Settings";
import OrganisationSync from "@/components/organisation/apple/Sync";

export default [
    {
        name: "schooldata.upload",
        path: "/schooldata/upload",
        component: SftpUpload,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        }
    },
    {
        name: "classes",
        path: "/classes",
        component: Classes,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        }
    },
    {
        name: "organisation.schools",
        path: "/organisation/schools",
        component: OrganisationSchools,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false
        }
    },
    {
        name: "organisation.settings",
        path: "/organisation/settings",
        component: OrganisationSettings,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false,
            requiresEnterprise: true
        }
    },
    {
        name: "organisation.sync",
        path: "/organisation/sync",
        component: OrganisationSync,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false,
            requiresEnterprise: true
        }
    },
];

